var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import _ from 'lodash';
import VueDialog from "../../../interface/IVueDialog";
import ThirdPartySystemService from '../../../api/ThirdPartySystemService';
import { Prop } from 'vue-property-decorator';
import AddGoodTable from './AddGoodTable.vue';
var EActiveType;
(function (EActiveType) {
    EActiveType["UNSELECTED"] = "UNSELECTED";
    EActiveType["SELECTED"] = "SELECTED";
})(EActiveType || (EActiveType = {}));
var AddDialog = (function (_super) {
    __extends(AddDialog, _super);
    function AddDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeName = 'UNSELECTED';
        _this.periodicList = [];
        _this.total = 0;
        _this.unSelectList = [];
        _this.selectedList = [];
        _this.canFreshTable = true;
        _this.loading = false;
        _this.categoryData = [];
        _this.shopList = [];
        _this.formData = {
            goods_type_ids: '',
            keyword: '',
            shop_id: '',
        };
        return _this;
    }
    AddDialog.prototype.created = function () {
        this.thirdPartySystemService = ThirdPartySystemService.getInstance();
        this.selectedList = [];
    };
    AddDialog.prototype.goodsTypeSelect = function (node) {
        this.formData.goods_type_ids = node.id;
        var pagination = this.$refs.pagination;
        if (pagination) {
            pagination.clear();
        }
        this.search();
    };
    AddDialog.prototype.shopSelect = function (value) {
        this.formData.shop_id = value;
        var pagination = this.$refs.pagination;
        if (pagination) {
            pagination.clear();
        }
        this.search();
    };
    AddDialog.prototype.getShopList = function () {
        var _this = this;
        this.thirdPartySystemService.getScmShopList({
            api_url: this.params.api_url,
        }).then(function (res) {
            if (res.data.success) {
                _this.shopList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    AddDialog.prototype.getCategory = function () {
        var _this = this;
        this.thirdPartySystemService.getScmGoodTypeTree({
            api_url: this.params.api_url,
        }).then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    AddDialog.prototype.getIds = function (arr, key) {
        if (!this.purchasers)
            return null;
        return _.reduce(arr, function (ori, newItem) {
            return ori += ori ? (',' + newItem[key]) : newItem[key];
        }, '');
    };
    AddDialog.prototype.getGoodList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        this.loading = true;
        var goods_ids;
        if (this.added_goods_ids && this.added_goods_ids.length) {
            goods_ids = this.added_goods_ids;
        }
        else {
            goods_ids = (this.addedDatas || []).map(function (item) {
                return item.goods_format_id;
            });
        }
        this.thirdPartySystemService.getScmGoodsList(Object.assign({}, {
            api_url: this.params.api_url,
            goods_type_ids: this.formData.goods_type_ids,
            keyword: this.formData.keyword,
            shop_id: this.formData.shop_id,
        }, pager)).then(function (res) {
            if (res.data.success) {
                console.log(res);
                _this.unSelectList = res.data.data;
                _this.total = res.data.total;
                _this.setSelected(true);
            }
            else {
                _this.$message.error(res.data.msg);
            }
            _this.loading = false;
        }, function (err) {
            _this.$message.error(err.message);
            _this.loading = false;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            _this.loading = false;
        });
    };
    AddDialog.prototype.selectChange = function (rows, currentRow, isSelectAll) {
        var _this = this;
        if (isSelectAll === void 0) { isSelectAll = false; }
        if (!this.canFreshTable)
            return;
        this.canFreshTable = false;
        var currentSelectRows = _.filter(rows, function (row) { return !!row; });
        this.selectedList = _.uniqBy(this.selectedList.concat(currentSelectRows), 'lgid');
        var isUnselectAll = !currentSelectRows.length && !currentRow && isSelectAll;
        if (currentRow && !_.find(currentSelectRows, function (good) { return good.lgid === currentRow.lgid; })) {
            _.remove(this.selectedList, function (good) { return good.lgid === currentRow.lgid; });
        }
        else if (isUnselectAll && this.activeName === EActiveType.SELECTED) {
            this.selectedList = [];
        }
        else if (isUnselectAll) {
            this.unSelectList.forEach(function (good) {
                _.remove(_this.selectedList, function (item) { return item.lgid === good.lgid; });
            });
        }
        this.setSelected(this.activeName === EActiveType.SELECTED);
        setTimeout(function () {
            _this.canFreshTable = true;
        });
    };
    AddDialog.prototype.setSelected = function (isUnSelFresh) {
        var _this = this;
        if (isUnSelFresh === void 0) { isUnSelFresh = false; }
        var gridTable = this.$refs.grid.$refs.table;
        if (isUnSelFresh) {
            gridTable.clearSelection();
        }
        if (!this.selectedList.length) {
            this.$refs.alreadyGrid.$refs.table.clearSelection();
        }
        else {
            this.selectedList.forEach(function (good, index) {
                _this.$nextTick(function () {
                    _this.$refs.alreadyGrid.$refs.table.toggleRowSelection(good, true);
                });
                if (isUnSelFresh) {
                    var item_1 = _.find(_this.unSelectList, function (current) { return current.goods_format_id === good.goods_format_id && current.lgid === good.lgid; });
                    if (item_1) {
                        _this.$nextTick(function () {
                            gridTable.toggleRowSelection(item_1, true);
                        });
                    }
                }
            });
        }
    };
    AddDialog.prototype.search = function () {
        var pagination = this.$refs.pagination;
        var currentPager = pagination ? pagination.getPage() : { page: 1, start: 0, limit: 20 };
        this.getGoodList(currentPager);
    };
    AddDialog.prototype.pageChange = function (pager) {
        this.getGoodList(pager);
        this.$refs.grid.$refs.table.bodyWrapper.scrollTop = 0;
    };
    AddDialog.prototype.normalizer = function (node) {
        return {
            id: node.id,
            label: node.text,
            children: node.children,
        };
    };
    AddDialog.prototype.getSelectedList = function () {
        return this.selectedList;
    };
    AddDialog.prototype.resetAll = function () {
        this.selectedList = [];
        this.unSelectList = [];
        this.formData = {
            goods_type_ids: '',
            keyword: ''
        };
    };
    __decorate([
        Prop({
            type: Object,
            required: true
        })
    ], AddDialog.prototype, "params", void 0);
    AddDialog = __decorate([
        Component({
            components: {
                'add-good-table': AddGoodTable
            },
            computed: {
                isMultiple: function () {
                    return _.uniqBy(this.purchasers, 'business_id').length > 1;
                }
            }
        })
    ], AddDialog);
    return AddDialog;
}(VueDialog));
export default AddDialog;
